import { render, staticRenderFns } from "./svg-pinterest.vue?vue&type=template&id=b1c83248&"
import script from "./svg-pinterest.vue?vue&type=script&lang=js&"
export * from "./svg-pinterest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports